export const orderApi = '/api/v1/store/order';
